import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { retrieveToken } from "../../../utils/storage";

export const userCategoriesApi = createApi({
  reducerPath: "userCategories",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getUserCategories: builder.query({
      query: () => ({
        url: "/data/maincategories",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${retrieveToken()}`,
        },
      }),
    }),
  }),
});

export const { useGetUserCategoriesQuery } = userCategoriesApi;
